// extracted by mini-css-extract-plugin
export default {"deleteToggleModal":"ToggleDeleteAttributeModal_deleteToggleModal__7rKwn","buttonCont":"ToggleDeleteAttributeModal_buttonCont__GEvgn"};